import React from 'react';

/**
 * ProVault logo + wordmark.
 *
 * - variant="full": icon + ProVault + 2-line tagline (default)
 * - variant="compact": icon + ProVault only (better for narrow sidebars)
 */
export default function Logo({ size = 48, variant = 'full' }) {
  const iconSize = Math.round(size * 1.1); // Increase shield by 10%
  const wordmarkSize = Math.round(size * 0.375); // ~18 when size=48
  const taglineSize = Math.max(9, Math.round(size * 0.208)); // ~10 when size=48
  const gap = Math.max(2, Math.round(size * 0.125)); // ~6 when size=48

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: gap }}>
      <svg width={iconSize} height={iconSize} viewBox="0 0 48 48" fill="none" aria-label="ProVault Shield">
        <rect width="48" height="48" rx="12" fill="#5c8d78" />
        <path d="M24 9 L37 15 L37 25 C37 32 31 36 24 40 C17 36 11 32 11 25 L11 15 L24 9 Z" fill="#ffffff"/>
        <circle cx="24" cy="23" r="2.2" fill="#5c8d78"/>
        <rect x="23" y="25.5" width="2" height="6" rx="1" fill="#5c8d78"/>
      </svg>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: Math.max(1, Math.round(gap * 0.5)) }}>
        <span style={{ color: '#ffffff', fontWeight: 600, letterSpacing: 0.2, lineHeight: 1, fontSize: wordmarkSize }}>ProVault</span>
        {variant !== 'compact' && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0 }}>
            <span style={{ color: '#ffffff', letterSpacing: 1, lineHeight: 1, textTransform: 'uppercase', fontSize: taglineSize }}>Secure your future.</span>
            <span style={{ color: '#ffffff', letterSpacing: 1, lineHeight: 1, textTransform: 'uppercase', fontSize: taglineSize }}>Simplify theirs</span>
          </div>
        )}
      </div>
    </div>
  );
}


